import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { of } from "rxjs";
import { stopExperimentActionTypes, emergencyStopExperimentLoading, emergencyStopExperimentLoaded } from "./Shutdown.ducks.js";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import EmergencyShutdownResource from "@ane/exp-data/lib/resources/EmergencyShutdown.resource";
const emergencyStopExperimentArgs = {
  filterOnType: stopExperimentActionTypes.LOAD,
  loadResource: (payload) => {
    const { experimentId } = payload;
    return EmergencyShutdownResource.stopExperiment(experimentId);
  },
  loadingAction: emergencyStopExperimentLoading,
  loadedAction: (successData, payload, error) => {
    return of(emergencyStopExperimentLoaded(payload, getCompletedAsyncWrapperObj(payload.experimentId, error)));
  }
};
const emergencyStopExperimentEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(emergencyStopExperimentArgs);
export {
  emergencyStopExperimentEpic as default,
  emergencyStopExperimentEpic
};
//# sourceMappingURL=Shutdown.epics.js.map
